<template>
  <div>
    <div
      id="HeaderContainer"
      class="header-container body-max-container desktop"
      :class="{ 'header-container-relative': positionRelation }"
    >
      <div class="header-body">
        <el-row>
          <el-col :span="6">
            <img
              alt="logo"
              src="../assets/img/logo_title.svg"
              class="logo enter-btn"
              @click="goPage('Home')"
            />
          </el-col>
          <el-col :span="3">
            <li>
              <span @click="goPage('About')">關於我們</span>
            </li>
          </el-col>
          <el-col :span="3">
            <li>
              <span @click="goPage('News')">最新消息</span>
            </li>
          </el-col>
          <el-col :span="3">
            <li>
              <span @click="goPage('ResourceIndex')">教育資源</span>
            </li>
          </el-col>
          <el-col :span="3">
            <li>
              <span @click="goPage('Thanks')">感謝名單</span>
            </li>
          </el-col>
          <el-col :span="3">
            <li>
              <el-dropdown @command="goPage" placement="bottom" :show-timeout="0" trigger="hover">
                <span class="el-dropdown-link">線上電影院</span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="12Nights">十二夜</el-dropdown-item>
                  <el-dropdown-item command="12Nights2" divided>十二夜2</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </li>
          </el-col>
          <el-col :span="3">
            <img v-if="isLogin" src="../assets/img/icon-user-cat.png" class="user-avatar" alt @click="goPage('UserInfo')" />
            <img v-else src="../assets/img/icon-user.svg" class="user-avatar" alt @click="goPage('Login')" />
          </el-col>
        </el-row>
      </div>
    </div>
    <div
      id="HeaderContainer"
      class="header-container header-container-relative mobile"
      :class="{ active: showMobileMenu }"
    >
      <div class="header-body">
        <div class="mobile-header-bar">
          <div class="mobile-header-logo" @click="goPage('Home')">
          </div>
          <div class="mobile-header-icon mobile-header-user-icon">
            <img v-if="isLogin" src="../assets/img/icon-user-cat.png" class="user-avatar" alt @click="goPage('UserInfo')" />
            <img v-else src="../assets/img/icon-user.svg" class="user-avatar" alt @click="goPage('Login')" />
          </div>
          <!--
          <div class="mobile-header-icon mobile-header-search-icon"><img src="../assets/img/icon_search.svg" alt></div>
          -->
          <div class="mobile-header-icon mobile-header-menu-icon" @click="handleMenuActive(!showMobileMenu)"><img src="../assets/img/icon_menu.svg" alt></div>
        </div>
        <div class="mobile-header-menu">
          <el-input
            placeholder="請輸入關鍵字">
            <i slot="suffix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <ul>
            <li @click="goPage('About')">關於我們</li>
            <li @click="goPage('News')">最新消息</li>
            <li @click="goPage('ResourceIndex')">教學資源</li>
            <li>線上電影院
              <div class="mobile-header-submenu" @click="goPage('12Nights')">
                <div></div>
                <span>十二夜</span>
              </div>
              <div class="mobile-header-submenu" @click="goPage('12Nights2')">
                <div></div>
                <span>十二夜2</span>
              </div>
            </li>
            <!--
            <li @click="goPage('Thanks')">常見問題</li>
            -->
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DeviceTypeEnum } from "@/utils/enum";

export default {
  name: "HeaderComponent",
  props: {
    positionRelation: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showMobileMenu: false,
      keyword: "",
      isShowHeader: true
    };
  },
  computed: {
    isLogin() {
      return this.$store.getters.token
    }
  },
  watch: {
  },
  mounted() {
    // const _this = this;
    window.onscroll = function() {
      // _this.isShowHeader = window.pageYOffset < 100;
    };
  },
  methods: {
    handleMenuActive(active) {
      this.showMobileMenu = active
      if (this.$store.getters.device === DeviceTypeEnum.MOBILE) {
        document.body.style.overflowY = active ? "hidden" : "";
        document.body.style.position = active ? "fixed" : "";
      }
    },
    goPage(page) {
      console.log(`go page : ${page}`)
      if (page === "12Nights") {
        this.$12nightsConfirm({
          title: "您將前往前往外部連結",
          message: "https://youtu.be/aCRzgAWj7nI"
        }).then(() => {
          this.handleMenuActive(false)
          window.open("https://youtu.be/aCRzgAWj7nI", '_blank')
        })
      } else if (page === "12Nights2") {
        this.$12nightsConfirm({
          title: "您將前往前往外部連結",
          message: "https://youtu.be/PfZdrRygmec"
        }).then(() => {
          this.handleMenuActive(false)
          window.open("https://youtu.be/PfZdrRygmec", '_blank')
        })
      } else if (this.$route.name !== page) {
        this.handleMenuActive(false)
        this.$router.push({
          name: page
        });
      } else {
        this.handleMenuActive(false)
      }
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
<style lang="scss">
$headerHeight: 58px;
.el-dropdown-menu {
  min-width: 120px;
  text-align: center;
  font-size: 1.4em;
  box-shadow: unset;
  border: 0;
  background-color: #D9E5C8;
  padding: 0 10px;
  .el-dropdown-menu__item {
    font-size: 1em !important;
    line-height: 2.2em;
    font-family: GenJyuuGothicL, venir, Helvetica, Arial, sans-serif;
  }
  .el-dropdown-menu__item:hover {
    background-color: transparent;
  }
  .el-dropdown-menu__item--divided {
    border-color: #62E0BB;
  }
  .el-dropdown-menu__item--divided:before {
    height: 1px !important;
    background-color: #62E0BB;
  }
}
.el-popper {
  margin-top: 1px !important;
  .popper__arrow {
    display: none;
  }
}

</style>
